module.exports = __webpack_public_path__ + "img/cns_printer_pc22.429b28c2.png";